import { FC, useEffect } from 'react';

import I18n from 'I18n';
import { useUnifiedAccount } from 'unified-auth';
import PortalIdParser from 'PortalIdParser';

import { TServiceComponentProps } from '../../types/service-component';
import { TReconnectMetadata } from '../../types/reconnect-metadata';

export const UnifiedAccServiceComponent: FC<TServiceComponentProps> = ({
  metadata = {} as TReconnectMetadata,
  onAuthCancelled,
  onAuthSucceeded,
  reconnectStarted,
}) => {
  const portalId = PortalIdParser.get() as number;
  const appId = metadata.appId || 0;
  const accountId = metadata.accountId || '0';
  const unifiedAccountId = metadata.unifiedAccountId || 0;
  const isUnifiedAccountMigration = !!metadata.isUnifiedAccountMigration;

  const onComplete = (response: { accountId: number }) => {
    onAuthSucceeded?.(String(response.accountId));
  };

  const onCancel = () => {
    onAuthCancelled?.({
      message: I18n.text('reconnect.warnings.reconnectionCancelled'),
    });
  };

  const { isLoading, Modal, openModal, isOpen } = useUnifiedAccount(
    {
      appId,
      portalId,
      accountId: unifiedAccountId || Number(accountId),
      ...(isUnifiedAccountMigration &&
        !unifiedAccountId && {
          oAuthorAccountId: accountId ? `${accountId}` : '',
        }),
    },
    {
      onComplete,
      onCancel,
    }
  );

  useEffect(() => {
    if (reconnectStarted && !isOpen && openModal) {
      openModal();
    }
  }, [reconnectStarted, isOpen, openModal]);

  return reconnectStarted && !isLoading && isOpen ? Modal : null;
};
